module.exports = __webpack_public_path__ + "static/hero-e1e2d8eae31c85740444502feae41c19.png";